import React from "react";
import image from './assets/about.jpg';
function About()
{
    return(
        <>
        <div className="pagecontainer"> 
           <div className="flexrow">
                <div className="itembox">
                <h1>Its a About Page</h1>
        <p>Get in touch with us here.</p>
                </div>

                 <div className="itembox">
                 <img src={image} alt="aboutus" className="aboutimg"/>
                 </div>
           </div>

        </div>
       
        </>
    );
};
export default About;